"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _functions = require("../../util/functions");
require("./DetailsRow.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faExternalLinkAlt);
class DetailsRow extends _react.Component {
  // Find a given aggregate fundamental in the list of keys and values
  getAggFundamentalValue(aggregateFundamentals, statName) {
    let value;
    aggregateFundamentals.keys.forEach((agg, index) => {
      if (agg === statName) {
        value = aggregateFundamentals.values[index];
      }
    });
    return value;
  }
  render() {
    const {
      fund
    } = this.props;
    if (fund.stdPerformance === null) {
      return null;
    }
    const urlFilings = fund.type === 'WTETF' ? 'https://www.wisdomtree.com/resource-library/prospectus-regulatory-reports' : 'https://doc.morningstar.com/docdetail.aspx?clientid=schwab&key=84b36f1bf3830e07&cusip=' + fund.cusip;
    const stdPerformance = Array.isArray(fund.stdPerformance) ? fund.stdPerformance[0] : fund.stdPerformance;

    // Set up Money Market yields differently, otherwise use SEC Yields
    let firstYield, secondYield;
    if (fund.fundCategoryTier1 === _functions.MONEY_MARKET && fund.aggregateFundamentals) {
      // Get the yields from the fund data in aggFund
      firstYield = this.getAggFundamentalValue(fund.aggregateFundamentals[0], "sevenDayYieldMM");
      secondYield = this.getAggFundamentalValue(fund.aggregateFundamentals[0], "sevenDayEffYieldMM");
    } else {
      firstYield = stdPerformance.sec30DayYieldSub;
      secondYield = stdPerformance.sec30DayYieldUnSub;
    }
    return /*#__PURE__*/_react.default.createElement("tr", {
      className: this.props.index === 0 ? 'whiteline' : 'greyline'
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: "textLeft row-name ticker sticky"
    }, fund.ticker), /*#__PURE__*/_react.default.createElement("td", {
      className: "textCenter filings"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "tickerLink",
      href: (0, _functions.getFundUrl)(fund),
      target: "_new"
    }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      className: "link-style",
      icon: "external-link-alt"
    }))), /*#__PURE__*/_react.default.createElement("td", {
      className: "textCenter filings"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "tickerLink",
      href: urlFilings,
      target: "_new"
    }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      className: "link-style",
      icon: "external-link-alt"
    }))), /*#__PURE__*/_react.default.createElement("td", {
      className: "textCenter category"
    }, new Date(fund.inceptionDate).toLocaleDateString()), /*#__PURE__*/_react.default.createElement("td", {
      className: "textCenter fees"
    }, (0, _functions.formatPercent)(fund.expenseRatioGross)), /*#__PURE__*/_react.default.createElement("td", {
      className: "textCenter fees"
    }, (0, _functions.formatPercent)(fund.expenseRatio)), /*#__PURE__*/_react.default.createElement("td", {
      className: "textCenter date"
    }, (0, _functions.formatPercent)(firstYield)), /*#__PURE__*/_react.default.createElement("td", {
      className: "textCenter date"
    }, (0, _functions.formatPercent)(secondYield)), /*#__PURE__*/_react.default.createElement("td", {
      className: "textLeft date"
    }, fund.expenseNotes));
  }
}
DetailsRow.propTypes = {
  /**
   * Index of row
   */
  index: _propTypes.default.number
};
var _default = exports.default = DetailsRow;